import type { InjectionKey, StyleValue } from 'vue'

export interface ScrollbarContext {
  scrollbarElement: HTMLDivElement
  wrapElement: HTMLDivElement
  stickyStyle: string | Array<StyleValue> | Record<string, unknown>
}

export const scrollbarContextKey: InjectionKey<ScrollbarContext> = Symbol(
  'scrollbarContextKey'
)
